"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brugherio": {
    "2be2177a": [{
      "hkey": "5fc0a129",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "baraggia": [{
      "hkey": "5fc0a129",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brugherio"
    }],
    "575eb899": [{
      "hkey": "5fc0a129",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "dorderio": [{
      "hkey": "5fc0a129",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brugherio"
    }],
    "1a2f81d5": [{
      "hkey": "5fc0a129",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "moncucco": [{
      "hkey": "5fc0a129",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brugherio"
    }]
  }
};
exports["default"] = _default;